import { LabInfo } from "../../dental-lab-info/lab-info";

export const AdminLabInfo = () => {
    return (
        <div className="admin-section">
            <LabInfo editable={false} labExist={true} />
        </div>
    );
};
